<template>
    <div v-if="page_init" style="padding-top: 1rem;background-color: #f5f5f5">
        <navTitle :title="$router.app._route.query.ti ? $router.app._route.query.ti : 'Activity area'"></navTitle>
        <div class="flex-container">
            <div class="flex-item">Active Code</div>
            <div class="flex-item"><input class="input" placeholder="Enter your code" v-model="exchange_code"/>
            </div>
            <div class="flex-item button1" @click="exchangeCode">Submit</div>
        </div>
        <div class="flex-container" @click="luckyAward">
            Lucky jackpot
        </div>
        <div class="flex-container" @click="$router.push({path: '/turntable'})">
            Turntable
        </div>
        <div class="flex-container" @click="$router.push({path: '/club'})">
            IM Club
        </div>
        <div class="flex-container" v-if="statistical_data['is_club_test']"
             @click="$router.push({path: '/club/lottery'})">
            IM Club Lottery
        </div>
        <div class="flex-container">
            Stay tuned
        </div>
        <div>
            <table>
                <tr>
                    <td>Cumulative registration</td>
                    <td>{{statistical_data['user_num']}}</td>
                </tr>
                <tr>
                    <td>Cumulative withdrawals</td>
                    <td>₱{{statistical_data['all_withdraw']}}</td>
                </tr>
                <tr>
                    <td>Cumulative commission</td>
                    <td>₱{{statistical_data['brokerage_price']}}</td>
                </tr>
            </table>
        </div>
        <div class="s-d-title">When the above data reaches a certain amount,rewards will be given to all members!</div>
<!--        <Football/>-->
        <div style="height: 1.5rem;"></div>
        <div v-if="statistical_data['christmas_decoration']===1" style="background-color: #fff;margin-top: 3px">
            <div class="christmas-gift" @click="christmasRaffleFun"></div>
            <mt-popup class="popup-con" v-model="popupVisible">
                <div class="ch-receive-alert">
                    <div class="ch-tip-title">Congratulations</div>
                    <div class="ch-tip-content">New Year's gift is {{award_info['type']===0?'points':'₱'}} {{award_info['num']}}</div>
                    <div class="ch-prize-btn">
                        <Button class="ch-prize-con-btn" type="primary" size="small" @click="closeAward()">
                            Confirm
                        </Button>
                    </div>
                </div>
            </mt-popup>
        </div>
        <div v-if="statistical_data['christmas_decoration']===2" style="background-color: #fff;margin-top: 3px">
            <div class="christmas-gift1" @click="christmasRaffleFun"></div>
            <mt-popup class="popup-con" v-model="popupVisible">
                <div class="ch-receive-alert1">
                    <div class="ch-tip-title">Congratulations</div>
                    <div class="ch-tip-content">Year of the Dragon Gift is {{award_info['type']===0?'points':'₱'}} {{award_info['num']}}</div>
                    <div class="ch-prize-btn">
                        <Button class="ch-prize-con-btn" type="primary" size="small" @click="closeAward()">
                            Confirm
                        </Button>
                    </div>
                </div>
            </mt-popup>
        </div>
    </div>
</template>

<script>
    import {Button, Popup} from 'mint-ui';
    import 'mint-ui/lib/style.css';
    import navTitle from "@components/navTitle"
    import Football from "@components/Football"
    import {exchange_code, statistical_data, DebounceBy} from "@api/user"
    import {
        christmasRaffle
    } from "../../api/activity"

    export default {
        name: "activityArea",
        components: {
            navTitle,
            Button,
            Football,
            'mt-popup': Popup
        },
        data() {
            return {
                page_init: false,
                popupVisible: false,
                exchange_code: '',
                statistical_data: '',
                award_info: ''
            }
        },
        mounted() {
            this.statisticalData()
        },
        methods: {
            christmasRaffleFun: DebounceBy(function () {
                let that = this
                christmasRaffle().then(res => {
                    that.award_info = res.data
                    that.popupVisible = true
                }).catch(res => {
                    that.$dialog.toast({mes: res.msg});
                })
            }, 3000),
            closeAward() {
                this.popupVisible = false
            },
            exchangeCode() {
                if (this.exchange_code === '') {
                    return this.$dialog.toast({mes: "Please fill in the exchange code"})
                }
                let that = this
                exchange_code({verification_code: that.exchange_code}).then(res => {
                    that.$dialog.success(res.msg);
                    // that.User();
                }).catch(res => {
                    that.$dialog.error(res.msg);
                })
            },
            luckyAward() {
                this.$router.push({path: '/lucky-award'})
            },
            statisticalData() {
                let that = this
                statistical_data().then(res => {
                    that.statistical_data = res.data
                    that.page_init = true
                    // console.log(that.statistical_data)
                })
            }
        }
    }
</script>

<style scoped>
    .flex-container {
        margin: 10px 1%;
        display: -webkit-flex;
        display: flex;
        -webkit-justify-content: space-around;
        justify-content: space-around;
        background-color: #fff;
        width: 98%;
        padding: 8px 3px;
        border-radius: 5px;
    }

    .button1 {
        background: rgb(0, 195, 249);
        color: #fff;
        padding: 2px;
        border-radius: 5px;
    }

    /*table {
        border-collapse: collapse; !* 合并边框 *!
        width: 98%;
        margin-left: 1%;
        text-align: center;
        background-color: #fff;
    }
    th {
        background-color: #f2f2f2;
        text-align: left;
    }
    td, th {
        border: 1px solid #dddddd; !* 设置边框为1像素的实线，可以根据需要修改颜色 *!
        padding: 8px; !* 设置单元格内边距 *!
    }

    .s-d-title{
        border-radius: 5px;
        width: 98%;
        margin-left: 1%;
        margin-top: 10px;
        background-color: #fff;
        padding: 10px 5px;
        font-size: .35rem;
    }*/
    table {
        width: 98%;
        margin-left: 1%;
        border-collapse: collapse;
        background-color: #f7e1e1; /* 柔和的粉色背景 */
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); /* 轻微阴影 */
    }

    th, td {
        padding: 10px;
        text-align: center;
        border: 1px solid #fff; /* 粉色边框 */
        border-radius: 5px; /* 圆角边框 */
        /*color: white;*/
        /*font-family: 'Comic Sans MS', cursive;*/
    }

    th {
        background-color: #00C3F9; /* 粉色表头背景 */
        color: white;
        /*font-family: 'Comic Sans MS', cursive; !* 可爱字体 *!*/
    }

    tr:nth-child(even) {
        background-color: #ffe4e4; /* 淡粉色交替行背景 */
    }

    .s-d-title {
        border-radius: 5px;
        width: 98%;
        margin-left: 1%;
        margin-top: 10px;
        background-color: #fff;
        padding: 10px 5px;
        font-size: .35rem;
        /*font-family: 'Comic Sans MS', cursive; !* 可爱字体 *!*/
    }

    .christmas-gift {
        width: 100%;
        height: 6rem;
        /*background-image: url("../../assets/images/christmas-gift.gif");*/
        background-image: url("../../assets/images/new_year_gift.gif");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        margin-top: -40px;
    }
    .christmas-gift1 {
        width: 100%;
        height: 6rem;
        background-image: url("../../assets/images/year/new_year4.gif");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        margin-top: -40px;
    }
    .popup-con {
        background: none;
    }
    .ch-receive-alert {
        width: 300px;
        height: 230px;
        background-image: url("../../assets/images/cbg.gif");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .ch-receive-alert1 {
        width: 300px;
        height: 230px;
        background-image: url("../../assets/images/year/new_year_bg.gif");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .ch-tip-title {
        color: #fff;
        font-weight: bold;
        font-size: .35rem;
        margin-top: 10px;
        text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #fff;
    }

    .ch-tip-content {
        color: gold;
        font-size: .3rem;
        margin-top: 20px;
        text-shadow: 0 0 10px gold, 0 0 20px gold, 0 0 30px gold;
    }

    .ch-prize-btn {
        margin-top: 20px;
    }
    .ch-prize-con-btn{
        background-color: gold;
    }
</style>